import { Component, OnInit, Inject } from '@angular/core';
import { LicenceTableDto } from 'src/app/entity/licenceTableDto';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LicenceService } from '../licence.service';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';

@Component({
  selector: 'app-licence-edit-view',
  templateUrl: './licence-edit-view.component.html',
  styleUrls: ['./licence-edit-view.component.scss'],
})
export class LicenceEditViewComponent implements OnInit {
  entity: LicenceTableDto;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<LicenceEditViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LicenceTableDto,
    private licenceService: LicenceService,
    private snackService: SnackbarService
  ) {
    this.entity = data;
  }

  ngOnInit(): void {}

  save(): void {
    if (
      this.entity.name === undefined ||
      this.entity.name === '' ||
      this.entity.to === undefined
    ) {
      this.snackService.open('shared.snackbar.validationError', 6, 'failed');
      return;
    }

    this.licenceService.saveLicence(this.entity).subscribe(
      (res) => {
        this.snackService.open('licence.edit.snackbar.edited', 4, 'success');
        this.dialogRef.close();
      },
      (error) => {
        this.snackService.open('shared.snackbar.error', 4, 'failed');
      }
    );
  }

  abort(): void {
    this.dialogRef.close();
  }
}
